var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('canvas',{ref:"canvas",style:(_vm.canvasStyle)}),(_vm.isDescargable)?_c('div',{staticClass:"text-center mt-4"},[_c('v-btn',{attrs:{"block":"","small":"","color":"primary"},on:{"click":_vm.downloadImage}},[_vm._v(" Descargar ")])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }